/*
 * @Author: Risker-C
 * @Date: 2021-09-13 16:28:00
 * @LastEditTime: 2021-09-17 10:05:23
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\business\businessService.ts
 */

import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ids } from "../projectCase/caseTypes";
import { IBusinessDetail } from "./businessTypes";

class BusinessService {
    async page(searchVo: IBusinessDetail) {
        const apiUrl = "/web/business/search_page";
        return await httpRequest.post<IPage<IBusinessDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/business/search_one/${id}`;
        return await httpRequest.get<IBusinessDetail>(apiUrl);
    }
    async insert(insertVo: IBusinessDetail) {
        const apiUrl = `/web/business/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IBusinessDetail) {
        const apiUrl = `/web/business/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(ids: ids) {
        const apiUrl = `/web/business/delete`;
        return await httpRequest.post<boolean>(apiUrl,ids);
    }
}
export const businessService = new BusinessService();
